import { useEffect, useState } from "react";
import { auth } from "../firebase";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";

function Dashboard() {
  const user = auth.currentUser;
  const navigate = useNavigate();

  const [count, setCount] = useState(0);
  const [lastScore, setLastScore] = useState(0);

  useEffect(() => {
  const user = auth.currentUser;
  const userKey = user?.email || "guest";

  const data = JSON.parse(
    localStorage.getItem(`solvedQuestions_${userKey}`)
  ) || [];

  setCount(data.length);

  const score = localStorage.getItem("lastScore") || 0;
  setLastScore(score);
}, []);

useEffect(() => {
  const interval = setInterval(() => {
    const user = auth.currentUser;
    const userKey = user?.email || "guest";

    const data = JSON.parse(
      localStorage.getItem(`solvedQuestions_${userKey}`)
    ) || [];

    setCount(data.length);
  }, 1000);

  return () => clearInterval(interval);
}, []);

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/");
  };

  const totalQuestions = 100;
  const progress = Math.round((count / totalQuestions) * 100);

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Dashboard 🚀</h1>

      <p style={styles.subtitle}>
        Welcome: <b>{user?.email}</b>
      </p>

      {/* CARDS */}
      <div style={styles.cardContainer}>
        <Card title="Solved Problems" value={count} color="#4CAF50" />
        <Card title="Progress" value={`${progress}%`} color="#2196F3" />
        <Card title="Last Score" value={`${lastScore} ⭐`} color="#FF9800" />
      </div>

      {/* PROGRESS BAR */}
      <div style={styles.progressBox}>
        <h3>Overall Progress</h3>

        <div style={styles.progressBg}>
          <div
            style={{
              ...styles.progressFill,
              width: `${progress}%`,
            }}
          ></div>
        </div>
      </div>

      {/* BUTTONS */}
      <div style={styles.btnContainer}>
        <button onClick={() => navigate("/practice")} style={styles.btn}>
          Practice 💻
        </button>

        <button onClick={() => navigate("/interview")} style={styles.btn}>
          Start Interview 🤖
        </button>

        <button onClick={() => navigate("/leaderboard")} style={styles.btn}>
          Leaderboard 🏆
        </button>

        <button onClick={handleLogout} style={styles.logout}>
          Logout
        </button>
      </div>
    </div>
  );
}

// 🔥 CARD COMPONENT
const Card = ({ title, value, color }) => (
  <div style={styles.card}>
    <h3>{title}</h3>
    <h2 style={{ color }}>{value}</h2>
  </div>
);

// 🔥 STYLES
const styles = {
  container: {
    padding: "30px",
    background: "#1e1e2f",
    minHeight: "100vh",
    color: "white",
  },

  title: {
    textAlign: "center",
  },

  subtitle: {
    textAlign: "center",
    marginBottom: "20px",
  },

  cardContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "20px",
    flexWrap: "wrap",
    marginTop: "20px",
  },

  card: {
    background: "rgba(255,255,255,0.1)",
    backdropFilter: "blur(10px)",
    borderRadius: "12px",
    padding: "20px",
    width: "200px",
    textAlign: "center",
    boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
  },

  progressBox: {
    marginTop: "40px",
    maxWidth: "500px",
    marginInline: "auto",
  },

  progressBg: {
    height: "12px",
    background: "#444",
    borderRadius: "10px",
  },

  progressFill: {
    height: "100%",
    background: "#4CAF50",
    borderRadius: "10px",
  },

  btnContainer: {
    textAlign: "center",
    marginTop: "40px",
  },

  btn: {
    padding: "12px 20px",
    margin: "10px",
    borderRadius: "10px",
    border: "none",
    background: "linear-gradient(135deg, #00c6ff, #0072ff)",
    color: "white",
    cursor: "pointer",
    fontWeight: "bold",
  },

  logout: {
    padding: "12px 20px",
    margin: "10px",
    borderRadius: "10px",
    border: "none",
    background: "red",
    color: "white",
    cursor: "pointer",
    fontWeight: "bold",
  },
};

export default Dashboard;